import { defineStore } from 'pinia';

export const useUserStore = defineStore('user', {
  state: () => ({ user: null, referralCode: null }),
  persist: true,
  getters: {
    getUser() {
        return this.user;
    },
    getReferralCode() {
        return this.referralCode;
      },
  },
  actions: {
    updateUser(user) {
        this.user = user;
    },
    updateReferralCode(referralCode) {
        this.referralCode = referralCode;
    },
  },
});